import React, { useState } from 'react';
import { IoChevronBack } from 'react-icons/io5';
import { PiPencilSimpleBold } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import useIsTeamMember from '../../../../hooks/useIsTeamMember';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import OnboardingCard from '../../onboarding/components/common/Card';
import InvestmentPreferences from '../../onboarding/components/investmentPreferences';
import { investmentPreferencesList } from '../../onboarding/components/investmentPreferences/Constant';

const SettingInvestmentPreferences: React.FC = () => {
    const isTeamMember: boolean = useIsTeamMember();
    const preferences = useSelector((state: RootState) => state.user.investor?.preferences);

    const [preferencesForm] = useState(investmentPreferencesList);
    const [isEdit, setEdit] = useState(false);
    const [preferencesIndex, setPreferencesIndex] = useState(-1);

    return (
        <div className="pt-4">
            {!isEdit && (
                <OnboardingCard>
                    <div className="flex w-full justify-between">
                        <div className="w-11/12">
                            {preferencesForm.map((p, index) => (
                                <div key={`${index}_${p.step}`}>
                                    <div className="flex justify-between w-full">
                                        <div className="flex flex-col">
                                            {p.data.map((p1, index1) => (
                                                <div key={`${index}_${index1}`} className="flex flex-col w-full">
                                                    <p
                                                        // style={{ color: 'rgb(110, 128, 157)' }}
                                                        className={`text-[12px] text-[#747474] font-[WorkSans-Semibold] pb-2 pt-4`}
                                                    >
                                                        {p1.headText}
                                                    </p>
                                                    <div style={{ minHeight: '3rem' }} className="flex flex-wrap">
                                                        {preferences &&
                                                            preferences[p1.type] &&
                                                            preferences[p1.type]?.map((pre) => (
                                                                <div
                                                                    key={pre}
                                                                    className="w-auto py-2 px-4 my-2 mr-2 rounded-3xl text-[#20222B] text-sm bg-[#E1EBF8]"
                                                                    // style={{ backgroundColor: '#E5E9FF' }}
                                                                >
                                                                    {pre === 'iDontKnow' ? 'I Don’t Know' : pre}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {!isTeamMember && (
                            <div
                                className="w-9 h-9 md:w-10 md:h-10 rounded-full  cursor-pointer flex justify-center items-center bg-[#F5F6FF]"
                                // style={{ backgroundColor: '#F5F6FF' }}
                                onClick={() => {
                                    setPreferencesIndex(1);
                                    setEdit(true);
                                }}
                            >
                                <PiPencilSimpleBold className="text-xl md:text-2xl" color="#13974B" />
                            </div>
                        )}
                    </div>
                </OnboardingCard>
            )}
            {isEdit && preferencesIndex > -1 && (
                <>
                    {preferencesIndex > 1 && (
                        <div className="relative">
                            <div className="flex justify-between items-center absolute -top-4 -left-2 md:left-0">
                                <HSButton
                                    type="link"
                                    title="Back"
                                    className="uppercase pl-0 text-base font-[WorkSans-Semibold]"
                                    style={{ color: '#1B3E8C' }}
                                    onClick={() => {
                                        setPreferencesIndex(preferencesIndex - 1);
                                    }}
                                    icon={<IoChevronBack />}
                                />
                            </div>
                        </div>
                    )}

                    <InvestmentPreferences
                        preferencesIndex={preferencesIndex}
                        setPreferencesIndex={(n: number) => setPreferencesIndex(n)}
                        isSetting={true}
                        onClickCancel={() => {
                            setEdit(false);
                            setPreferencesIndex(-1);
                        }}
                    />
                </>
            )}
        </div>
    );
};

export default SettingInvestmentPreferences;
